import { Button, Menu } from '@pocketlaw/tetris';
export function ConfigMenu(props) {
    const { children, label, secondary } = props;
    return (<Menu.Root target={<Button type="button" appearance="secondary" size="small">
          <span>
            <b>{label}</b> {secondary}
          </span>
        </Button>}>
      {children}
    </Menu.Root>);
}
